<template>
  <div id="app">
    <div v-if="autorizado">
      <router-view/>
    </div>
    <div class="d-flex justify-content-center bg-primary" style="height: 100vh" v-else>
      <div class="m-auto text-center">
        <img src="./assets/logo-white.png" alt="Logo Lecard" style="width: 184px;">
        <div class="text-white mt-2">
          <h6 class="text-white" v-if="errMsg">{{ errMsg }}</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService'

export default {
  data() {
    return {
      load: true,
      autorizado: false,
      key: '',
      user: {},
      audio: null,
      errMsg: null
    }
  },
  name: 'App',
  methods: {
    autenticar(token, profile) {
      AuthService.authenticate(token, profile)
        .then(data => {
          if (data.user && data.user.id_empresa) {
            this.$store.state.dataUser = data.user;

            if (profile === 'admin') {
              this.$socket.emit('chat_join_empresa', data.user.id_empresa);
            }

            this.autorizado = true;

          } else {
            this.errMsg = 'Usuário não autorizado!';
          }

        }).catch(res => {
          if (res.status === 401) {
            this.errMsg = 'Não foi possível autenticar este usuário!';
            sessionStorage.clear();
          }
        });
    }
  },

  mounted() {
    if (['ChatPedidoAuth', 'ChatPedido', 'ChatAdmin', 'Chats'].includes(this.$route.name)) {
      const profile = ['ChatPedidoAuth', 'ChatPedido'].includes(this.$route.name) ? 'client' : 'admin';
      const token = this.$route.query.auth || this.$route.query.t || sessionStorage.getItem('token');

      if (token) {
        this.$store.state.session = this.$helpers.ID();

        if (this.$route.name === 'ChatPedidoAuth') {
          sessionStorage.setItem("pedido", this.$route.params.id);
          this.$router.replace('/pedido');

        } else if (this.$route.query.auth || this.$route.query.t) {
          const query = { ...this.$route.query };
          delete query.auth;
          delete query.t;
          this.$router.replace({ path: this.$route.path, query });
        }

        this.autenticar(token, profile);
      }
    }
  },

  sockets: {
    chat_message(res) {
      if (res.play) {
        this.$store.commit('setBell', 1);
        this.playNotification();

      } else {
        this.$store.commit('setBell', false);
        this.pauseNotification();
      }
    },

    request_human(data) {
      if (data) {
        if (!this.audio) {
          this.audio = new Audio("https://lecard-cdn.nyc3.digitaloceanspaces.com/lecard-gestor/lebot-bell.mp3");
        }

        new Notification('Solicitação de atendimento!', {
          body: (data.nome_cliente ? 'O cliente: ' + data.nome_cliente : 'Um cliente') + ' solicitou atendimento',
          //icon: document.getElementById('imgEmpresa').src
        });

        if (this.audio && this.audio.paused) {
          this.audio.play();
        }

      } else if (!data && this.audio && !this.audio.paused) {
        this.audio.pause();
        this.audio.currentTime = 0;
      }
    }
  },
}
</script>
